import PropTypes from "prop-types";
import React from "react";

import CardSecondary from "../../../../UI/Card/CardSecondary";
import { ErrorCard, Text, TextColors, TextTypes } from "../../../../../component-library";

import "./styles.scss";

export const CardOnFile = ({
  cardEndsIn,
  dateAdded,
  expiresOn,
  hasCardExpired,
  hasCardOnFile,
  hasLoaded,
}) => {
  return (
    <CardSecondary className="CardOnFile-card">
      <div data-public>
        <p className="CardOnFile-title">Card on File</p>
        <div className="CardOnFile-line" />
      </div>

      {hasLoaded && (
        <>
          {hasCardExpired && (
            <ErrorCard className="CardOnFile-error" data-public>
              <Text color={TextColors.red} type={TextTypes.label}>
                This card has expired
              </Text>
            </ErrorCard>
          )}

          {hasCardOnFile && (
            <div className="CardOnFile-active_card_content">
              <div className="CardOnFile-column_container">
                <p className="CardOnFile-column_name" data-public>
                  Card Ending In
                </p>
                <p className="CardOnFile-column_content">{cardEndsIn}</p>
              </div>

              <div className="CardOnFile-column_container">
                <p className="CardOnFile-column_name" data-public>
                  Expires
                </p>
                <p className="CardOnFile-column_content">{expiresOn}</p>
              </div>

              <div className="CardOnFile-column_container" data-public>
                <p className="CardOnFile-column_name">Added</p>
                <p className="CardOnFile-column_content">{dateAdded}</p>
              </div>
            </div>
          )}
          {!hasCardOnFile && (
            <p className="CardOnFile-empty" data-public>
              No card on file.
            </p>
          )}
        </>
      )}
    </CardSecondary>
  );
};

CardOnFile.propTypes = {
  cardEndsIn: PropTypes.string,
  dateAdded: PropTypes.string,
  expiresOn: PropTypes.string,
  hasCardExpired: PropTypes.bool,
  hasCardOnFile: PropTypes.bool,
  hasLoaded: PropTypes.bool,
};
